import { render, staticRenderFns } from "./IngresosMPArticulo.vue?vue&type=template&id=7506a745&"
import script from "./IngresosMPArticulo.vue?vue&type=script&lang=js&"
export * from "./IngresosMPArticulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports